var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoDos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.0122,
    r: 31.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1945 44.9883V47H23.4016V45.1836L32.718 34.6172C33.8768 33.3021 34.8013 32.1497 35.4914 31.1602C36.1815 30.1576 36.6763 29.2461 36.9758 28.4258C37.2883 27.5924 37.4445 26.7852 37.4445 26.0039C37.4445 24.8581 37.2167 23.849 36.7609 22.9766C36.3182 22.1042 35.6542 21.4206 34.7688 20.9258C33.8833 20.431 32.7896 20.1836 31.4875 20.1836C30.1854 20.1836 29.0526 20.4635 28.0891 21.0234C27.1255 21.5833 26.3833 22.3646 25.8625 23.3672C25.3547 24.3568 25.1008 25.4831 25.1008 26.7461H22.7766C22.7766 25.1836 23.1216 23.7513 23.8117 22.4492C24.5148 21.1471 25.5174 20.112 26.8195 19.3438C28.1216 18.5625 29.6776 18.1719 31.4875 18.1719C33.2063 18.1719 34.6841 18.4779 35.9211 19.0898C37.1581 19.6888 38.1086 20.5547 38.7727 21.6875C39.4497 22.8203 39.7883 24.1875 39.7883 25.7891C39.7883 26.6484 39.632 27.5143 39.3195 28.3867C39.0201 29.2591 38.6034 30.1315 38.0695 31.0039C37.5487 31.8633 36.9497 32.7161 36.2727 33.5625C35.6086 34.4089 34.912 35.2422 34.1828 36.0625L26.2531 44.9883H41.1945Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoDos);
export default __webpack_public_path__ + "static/media/icono_dos.e13748e0542f87decb1a97910d5b4f22.svg";
export { ForwardRef as ReactComponent };